(function (root) {
  'use strict';
  const tiers = [{min:5,max:10},{min:11,max:15},{min:16,max:20},{min:21,max:Infinity}];
  function priceCents(value) {
    if (typeof value === 'number') return Number.isFinite(value) && value > 0 ? Math.round(value * 100) : null;
    const text = String(value ?? '').trim().replace(/\s/g, '').replace(',', '.');
    if (!/^\d+(\.\d{1,2})?$/.test(text)) return null;
    const price = Number(text);
    return Number.isFinite(price) && price > 0 ? Math.round(price * 100) : null;
  }
  function tierFor(quantity) {
    if (!Number.isSafeInteger(quantity) || quantity < 5) return -1;
    return tiers.findIndex(t => quantity >= t.min && quantity <= t.max);
  }
  function summarize(products, rows) {
    const groups = [];
    for (const product of products) {
      const lines = rows.filter(r => String(r.productId) === String(product.id) && Number.isSafeInteger(r.quantity) && r.quantity > 0);
      if (!lines.length) continue;
      const quantity = lines.reduce((sum, r) => sum + r.quantity, 0);
      const tier = tierFor(quantity);
      const unitPrice = tier < 0 ? null : priceCents(product.prices[tier]);
      groups.push({product, lines, quantity, tier, unitPrice, total:unitPrice === null ? null : quantity * unitPrice});
    }
    const complete = groups.length > 0 && groups.every(g => g.total !== null);
    return {groups, quantity:groups.reduce((s,g)=>s+g.quantity,0), complete, total:complete ? groups.reduce((s,g)=>s+g.total,0) : null};
  }
  function summarizePrints(clothing, selections, options) {
    const groups = clothing.groups.map(group => {
      const availableOptions = options.filter(option=>option.category===group.product.category);
      const eligible = availableOptions.length>0;
      const values = eligible ? selections[String(group.product.id)] || {} : {};
      const selected = Array.isArray(values) ? Object.fromEntries(values.map(id=>[id,1])) : values;
      const lines = availableOptions.filter(option=>Number.isSafeInteger(selected[option.id]) && selected[option.id]>0).map(option=>{
        const unitPrice = group.tier < 0 ? null : priceCents(option.prices[group.tier]);
        const perGarment = Math.min(option.maxPerGarment || 1,selected[option.id]);
        return {option, perGarment, garments:group.quantity, quantity:group.quantity*perGarment, tier:group.tier, unitPrice, total:unitPrice===null?null:group.quantity*perGarment*unitPrice};
      });
      const total = lines.some(line=>line.total===null) ? null : lines.reduce((sum,line)=>sum+line.total,0);
      return {productId:group.product.id, eligible, lines, total};
    });
    const total = groups.some(group=>group.total===null) ? null : groups.reduce((sum,group)=>sum+group.total,0);
    const pendingCategories = groups.some(group=>!group.eligible);
    return {groups,total,pendingCategories,grandTotal:clothing.total===null||total===null||pendingCategories?null:clothing.total+total};
  }
  const api = {tiers, priceCents, tierFor, summarize, summarizePrints};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.TTPackagePricing = api;
})(typeof window !== 'undefined' ? window : globalThis);

